module.exports = __webpack_public_path__ + "img/mockup-jabrutouch.59957445.png";